import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { InputProps } from './types';
import { useStyles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { setCustomData } from '../../Reducers/Configurator/Actions';
import { setProductParamsValid } from '../../Reducers/App/Actions';
import { getCustomData } from '../../Reducers/App/Selectors';

const CWSelectField: React.FC<InputProps> = (props) => {
  const { field } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const storedValue = useSelector((state) => getCustomData(state)?.[field.identifier]) || '';

  useEffect(() => {
    dispatch(
      setProductParamsValid({ [field.identifier]: field.validation?.required ? !!storedValue : true })
    );
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setCustomData({ [field.identifier]: value }));
    dispatch(setProductParamsValid({ [field.identifier]: field.validation?.required ? !!value : true }));
  };

  const placeholder = field.placeholderSlug ? t(field.placeholderSlug) : field.placeholder;

  return (
    <Grid container className={classes.component}>
      <Grid item xs={12}>
        <FormControl key={field.identifier} className={classes.formControl}>
          <Select
            variant="outlined"
            value={storedValue}
            onChange={handleChange}
            displayEmpty
            className={classes.select}
            renderValue={(value: string) =>
              value ? field.options?.find((o) => o.value === value)?.label || value : placeholder
            }
          >
            {(field.options || []).map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default CWSelectField;
